"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _event = require("./event");
Object.keys(_event).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _event[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _event[key];
    }
  });
});
//# sourceMappingURL=index.js.map